<template>
  <div class="cart-box">
    <div class="header-box">
      <div @click="changeTab(key)" :class="key == index ? 'header-box_active' : ''" v-for="(item, key) in headers" :key="key">{{ item }}</div>
    </div>
    <div class="cart-body">
      <personnal v-if="index == '0'" />
      <passwordView v-else />
    </div>
  </div>
</template>

<script>
import personnal from './item/personnal.vue'
import passwordView from './item/password.vue'
export default {
  name: 'profile',
  components:{ personnal, passwordView },
  data: () => ({
    index: 0,
    headers: ['Informations personnelles', 'Mot de passe']
  }),
  methods:{
    changeTab(key){
      this.index = key
    }
  }
}
</script>

<style lang="scss" scoped>
  .cart-box{
    width: 100%;
    min-height: 100px;
    height: auto;
    border: 1px solid #fff;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }
  .header-box{
    display: flex;
    gap: 20px;
    cursor: pointer;
  }
  .header-box_active{
    border-bottom: 3px solid #0C07AC;
  }
  .cart-body{
    margin-top: 20px;
  }
</style>
